module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_9006.8794ec37.png";